import React from 'react';
import PostForm from '../components/post/PostForm';

const EditPostGroupPage: React.FC = () => {
  return (
    <div>
      <PostForm mode="edit" />
    </div>
  );
};

export default EditPostGroupPage;
